<template>
  <div class="code-container">
    <Spinner />
  </div>
</template>

<script>
import Spinner from "@/components/facialRecognition/Spinner";
import { FFResultEvent } from "fulfillment-commons-js";

export default {
  name: "AuthPortalCode",
  components: {
    Spinner,
  },
  props: {
    portalService: { type: Object, required: true },
    rut: { type: String, required: true },
    company: { type: String, default: "cuprum" },
    durationInHours: { type: Number },
    validationMethods: { type: String },
    validationPurpose: { type: String },
    channelKey: { type: String, required: true },
    traceId: { type: String },
    jwt: { type: String },
  },
  data() {
    return {
      validationCode: undefined,
    };
  },
  created() {
    let customValidationMethods = undefined
    if (this.validationMethods) {
      try {
        customValidationMethods = JSON.parse(this.validationMethods);
      }
      catch  (e) {
        customValidationMethods = undefined;
        }
    }
    this.portalService
      .getValidationCode(
        {
          rut: this.rut,
          company: this.company,
          durationInHours: this.durationInHours,
          validationMethods: customValidationMethods,
          validationPurpose: this.validationPurpose,
        },
        this.channelKey,
        this.jwt
      )
      .then((response) => {
        this.validationCode = response.validationCode;
        this.successResponse(response);
      })
      .catch((error) => {
        this.failureResponse(error);
      });
  },
  methods: {
    successResponse(portalResponse) {
      this.$emit("result", FFResultEvent.success(portalResponse, this.traceId));
    },
    failureResponse(error) {
      this.$emit("result", FFResultEvent.failure(error, this.traceId));
    },
  },
};
</script>
<style scoped src="@pds/core/core.min.css"></style>
<style scoped src="@pds/typography/typography.min.css"></style>
<style>
  .code-container{
    width: 100%;
    text-align: center;
    padding-top: 30px;
  }
</style>
